import { useMutation } from "@apollo/client";
import { Button, getInput, Modal } from "../../../../../../../components/ui";
import { CREATE_EXHIBITION_WORK } from "../../../../../../../graphql/mutation/ExhibitionWork";
import { useFormik } from "formik";

const AddWorkModal = props => {
  const { closeModal, exhibition, isPlaceholder = false } = props;
  const [createExhibitionWork, { loading, error, reset }] = useMutation(
    CREATE_EXHIBITION_WORK(),
    {
      refetchQueries: [
        "FetchExhibitionWorks",
        "FetchExhibitionWorksV2",
        "FetchExhibition",
        "fetchConsignmentWorks",
      ],
    },
  );

  const handleClick = () => {
    createExhibitionWork({
      variables: {
        input: {
          exhibitionId: exhibition?.id,
          ...formik?.values,
        },
      },
    }).then(resp => {
      const { data: { createExhibitionWork: { success } = {} } = {} } = resp;

      if (success) {
        resetAll();
      }
    });
  };

  const formik = useFormik({
    initialValues: { instanceId: null },
    onSubmit: handleClick,
  });

  const resetAll = () => {
    formik?.resetForm();
    reset?.();
    closeModal?.();
  };

  const inputs = [
    !isPlaceholder && {
      label: "Instance",
      name: "instanceId",
      type: "instanceSearch",
    },
    {
      label: "Notes",
      name: "notes",
      type: "long-text",
    },
    {
      label: "Technical Notes",
      name: "technicalNotes",
      type: "long-text",
    },
  ];

  if (error) {
    return (
      <div className="mt-6 flex w-full flex-col">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start">
          <div className="flex flex-1 flex-col">
            <div className="text-2xl font-bold">Error adding work</div>
          </div>
          <div className="flex flex-wrap gap-2 sm:gap-4">
            <div>
              <Button
                action="default"
                className="sm:mr-2"
                label="Cancel"
                onClick={() => {
                  resetAll();
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="py-6">{error?.message}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start">
        <div className="flex flex-1 flex-col text-2xl font-bold">
          <div>
            {isPlaceholder ? "Add Placeholder" : "Add Exhibition Artwork"}
          </div>
        </div>
        <div className="flex flex-wrap gap-2 sm:gap-4">
          <Button action="default" label="Cancel" onClick={closeModal} />
          <Button
            label="Create"
            loading={loading}
            disabled={loading}
            onClick={formik.submitForm}
          />
        </div>
      </div>
      <div className="grid w-full grid-cols-1 gap-4">
        {inputs
          ?.filter(item => !!item)
          .map((item, index) => {
            const inputProps = {
              ...item,
              formik,
            };
            return <div key={index}>{getInput(inputProps)}</div>;
          })}
      </div>
    </div>
  );
};

const AddWork = props => {
  const { exhibition, disabled, isPlaceholder = false } = props || {};

  const modalProps = {
    body: AddWorkModal,
    closeOnBackdrop: false,
    exhibition,
    isPlaceholder,
    hideCloseButton: true,
    scale: "md",
    disabled,
  };

  return (
    <Modal {...modalProps}>
      <Button
        label={isPlaceholder ? "Add Placeholder" : "Add Work"}
        action="black"
        disabled={disabled}
      />
    </Modal>
  );
};

export default AddWork;
